import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import HomeIcon from "@mui/icons-material/HomeOutlined";
import PersonIcon from "@mui/icons-material/PersonOutline";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import DashboardIcon from "@mui/icons-material/DashboardOutlined";
import GridOnIcon from "@mui/icons-material/GridOn";
import LogoutIcon from "@mui/icons-material/Logout";
import AddIcon from "@mui/icons-material/Add";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import RoomPreferencesIcon from "@mui/icons-material/RoomPreferences";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import SubtitlesOffIcon from "@mui/icons-material/SubtitlesOff";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import SettingsIcon from "@mui/icons-material/Settings";
import HolidayVillageIcon from "@mui/icons-material/HolidayVillage";
import ScheduleIcon from "@mui/icons-material/Schedule";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import SearchIcon from "@mui/icons-material/Search";
import BeenhereOutlinedIcon from "@mui/icons-material/BeenhereOutlined";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import AppsIcon from "@mui/icons-material/Apps";
import LockPersonIcon from '@mui/icons-material/LockPersonOutlined';
import SortIcon from '@mui/icons-material/Sort';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import KeyIcon from '@mui/icons-material/VpnKey';
import AccountBalanceIcon from '@mui/icons-material/AccountBalanceOutlined';
import HowToRegIcon from '@mui/icons-material/HowToRegOutlined';
import {
  FaList,
  FaUsers,
  FaMoneyBill,
  FaBrush,
  FaQuoteLeft,
} from "react-icons/fa";
import { FcLeave } from "react-icons/fc";
import { BsPencilSquare } from "react-icons/bs";
import { PiCards } from "react-icons/pi";
import { GrTemplate } from "react-icons/gr";
import { MdWork, MdLeaderboard } from "react-icons/md";
import { TbBuildingEstate } from "react-icons/tb";
import { BiSolidRightArrowSquare, BiSolidLeftArrowSquare } from "react-icons/bi";
import { GiHidden } from "react-icons/gi";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TimeIcon from "@mui/icons-material/AccessTime";
import People from '@mui/icons-material/PeopleAltOutlined'
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import TaskIcon from "@mui/icons-material/Task";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import NoteIcon from "@mui/icons-material/EditNote";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import MinimizeIcon from "@mui/icons-material/Minimize";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import AllInclusiveOutlinedIcon from "@mui/icons-material/AllInclusiveOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import CallIcon from '@mui/icons-material/Call';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import GroupsIcon from "@mui/icons-material/Groups"
import SaveIcon from '@mui/icons-material/Save';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import SummarizeIcon from '@mui/icons-material/SummarizeOutlined';
import StoreIcon from '@mui/icons-material/StoreOutlined';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFileOutlined';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

export const WSIcons = {
  Edit: EditOutlinedIcon,
  Home: HomeIcon,
  Person: PersonIcon,
  TrendingUp: TrendingUpIcon,
  Annual: DashboardIcon,
  Masters: GridOnIcon,
  LogOut: LogoutIcon,
  AddIcon: AddIcon,
  UserGroup: GroupAddIcon,
  RolesIcon: RoomPreferencesIcon,
  ManageAccountIcon: ManageAccountsIcon,
  MedicalServicesIcon: MedicalServicesIcon,
  WithoutPay: SubtitlesOffIcon,
  ArrowRight: KeyboardArrowRightIcon,
  PersonOffIcon: PersonOffIcon,
  SettingsIcon: SettingsIcon,
  HolidayVillageIcon: HolidayVillageIcon,
  ScheduleIcon: ScheduleIcon,
  AnnouncementIcon: AnnouncementIcon,
  ShoppingBagIcon: ShoppingBagOutlinedIcon,
  CompareArrowsIcon: ImportExportIcon,
  FavoriteBorderIcon: FavoriteBorderIcon,
  SearchIcon: SearchIcon,
  BeenhereOutlinedIcon: BeenhereOutlinedIcon,
  SpaceDashboardIcon: SpaceDashboardIcon,
  AppsIcon: AppsIcon,
  FaListIcon: FaList,
  ShoppingCartOutlinedIcon,
  LocationOnIcon: LocationOnIcon,
  TimeIcon: TimeIcon,
  LocalOfferIcon: LocalOfferIcon,
  EmailIcon: EmailIcon,
  PhoneIcon: PhoneIcon,
  TaskIcon: TaskIcon,
  MeetingRoomIcon: MeetingRoomIcon,
  NoteIcon: NoteIcon,
  KeyboardArrowDownIcon: KeyboardArrowDownIcon,
  CloseIcon: CloseIcon,
  ArrowForwardIcon: ArrowForwardIcon,
  ArrowDownwardIcon: ArrowDownwardIcon,
  ChevronRightIcon: ChevronRightIcon,
  AccountCircleIcon: AccountCircleIcon,
  KeyboardDoubleArrowRightIcon: KeyboardDoubleArrowRightIcon,
  MinimizeIcon: MinimizeIcon,
  OpenInFullIcon: OpenInFullIcon,
  AttachFileIcon: AttachFileIcon,
  AppRegistrationIcon: AppRegistrationIcon,
  AllInclusiveOutlinedIcon: AllInclusiveOutlinedIcon,
  ErrorOutlineIcon: ErrorOutlineIcon,
  DeleteIcon: DeleteIcon,
  Download: DownloadIcon,
  Print: PrintIcon,
  Users: FaUsers,
  Billing: FaMoneyBill,
  Pencil: BsPencilSquare,
  Template: GrTemplate,
  Cards: PiCards,
  Brush: FaBrush,
  Report: SummarizeIcon,
  Work: MdWork,
  Quote: FaQuoteLeft,
  Leave: FcLeave,
  LockIcon: LockPersonIcon,
  Building: StoreIcon,
  People,
  Document: InsertDriveFileIcon,
  District: TbBuildingEstate,
  CallIcon,
  NotificationsNone: NotificationsNoneIcon,
  Filter: FilterAltIcon,
  Sort: SortIcon,
  LeadBoard: MdLeaderboard,
  Admin: AdminPanelSettingsIcon,
  Password: KeyIcon,
  Loan: AccountBalanceIcon,
  Group: GroupsIcon,
  Save: SaveIcon,
  RightArrowSquare: BiSolidRightArrowSquare,
  LeftArrowSquare: BiSolidLeftArrowSquare,
  Hidden: GiHidden,
  CurrencyRupee: CurrencyRupeeIcon,
  InfoIcon,
  WhatsApp: WhatsAppIcon,
  Approve: CheckBoxIcon,
  Completed: HowToRegIcon,
  Upload: CloudUploadIcon
};
